import { Component, OnInit, Injectable, ChangeDetectorRef } from '@angular/core';
import { PatientPortalDashboardService, PatientPortalMessageBoardService, GetPatientPortalAppointmentsService, GetPatientPortalMedicationListService, GetPatientPortalReceiptsService, GetPracticeMessagesService, GetPatientPortalStatementMenuService, GetPatientPortalMessageTypesService, PatientPortalSendMessageService, NewLoginMessageService, GetProviderDetailsForRegUserService, GetStatementReportService, GetPatientPaymentDetailsService, PracticeCloudStorageService, ClipBoardService } from '../services/api';
import { Router } from '@angular/router';
import { CommonService } from '../services/common.service';
import { PatientPortalDashBoard, PatientPortalMessageBoard, PatientPortalAppointments, MedicationData, PatientPortalReceipts, NewLoginMessage, PatientPortalMessage } from '../model/models';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import PerfectScrollbar from 'perfect-scrollbar';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
declare var $: any;
declare interface DataTable {
    headerRow: string[];
    footerRow: string[];
    dataRows: string[][];
}


@Component({
    moduleId: module.id,
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html'
})
@Injectable()
export class DashboardComponent implements OnInit {
    //this.toastr.success('login...', 'Success!');
    public dashboardRecords: PatientPortalDashBoard = {};
    public dashboardMedication: string;
   // public inboxData: PatientPortalMessageBoard[];
    public inboxData: PatientPortalMessage[];
    public appointmentData: PatientPortalAppointments[];
    public medicationData: MedicationData[];
    public recieptData: PatientPortalReceipts[];
    public clipboardData: any[] = [];
    public flag: string = '';
    public patId: number;
    public userId: number;
    public statementId: number = 0;
    public statementUrl: string;
    public messageTypes: any[];
    public msgType: string;
    public messageModalData: NewLoginMessage = {};
    statementURL: any;
    isDetails: boolean = true;
    public dataTable: DataTable;
    public dataRow: any;
    public dataHeader: any;

    public dataTable1: DataTable;
    public dataRow1: any;
    public dataHeader1: any;

    public dataTable2: DataTable;
    public dataRow2: any;
    public dataHeader2: any;
    public dataTable3: DataTable;
    public dataRow3: any;
    public dataHeader3: any;
    nextApp: string = '';
    amount: any;
    activeStatus: boolean = false;
    IsPaymentButtonHide: boolean = false;
    modalTitle: string = '';
    timeZone: string = '';
    prodType: string = '';
    pendingCB: number = 0;
    completedCB: number = 0;
    public bookOnline: any;
   // public msgModalData: PatientPortalMessageBoard = {};
    public msgModalData: PatientPortalMessage = {};
    public todaysDate: string = '';
    constructor(private dashboardService: PatientPortalDashboardService, private messageBoardService: PatientPortalMessageBoardService, private appointmentService: GetPatientPortalAppointmentsService, private medicationService: GetPatientPortalMedicationListService, private statementService: GetStatementReportService, private tokenService: CommonService, private router: Router, private alertService: GetPracticeMessagesService, private toastr: ToastrService, private stmenuService: GetPatientPortalStatementMenuService, private messageTypeService: GetPatientPortalMessageTypesService, private sendmsgService: NewLoginMessageService, private provService: GetProviderDetailsForRegUserService, private sanitizer: DomSanitizer, private spinner: NgxSpinnerService, private chRef: ChangeDetectorRef, private paymentService: GetPatientPaymentDetailsService, private msgService: PatientPortalSendMessageService, private configService: PracticeCloudStorageService, private clipboardService: ClipBoardService, public datepipe: DatePipe) {
        let userCred = localStorage.getItem('userVal');
        if (userCred == null) {
            this.router.navigate(['login']);
        }
    }
    ngOnInit() {
        this.spinner.show();
        this.prodType = environment.appSetting.prodType;
        this.flag = 'NewAppointments'
        this.todaysDate = this.datepipe.transform(new Date(), 'MM/dd/yyyy');
        let userCred = localStorage.getItem('userVal');
        this.timeZone = localStorage.getItem('timezone');
        var CryptoJS = require("crypto-js");
        var SECRET_KEY = 'm@duLeMD#2k19';
        let decrVal = CryptoJS.AES.decrypt(userCred, SECRET_KEY);
        decrVal = decrVal.toString(CryptoJS.enc.Utf8);
        let userData = JSON.parse(localStorage.getItem('usersession'));
        this.tokenService.GetPortalKey(decrVal.split(',')[0], decrVal.split(',')[1]);
        this.patId = userData[0].PatientId;
        this.userId = userData[0].UserId;
         this.bookOnline = userData[0].BookOnline;
        let headerContext: { [key: string]: string } = {};
        headerContext["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.UserPracticeId + "'}";
        this.dashboardService.configuration.apiKeys = headerContext;
        this.dashboardService.configuration.accessToken = environment.portalAccessKey;
        this.dashboardService.patientPortalDashboard(userData[0].PatientId).map(t => t).subscribe(data => {
            this.dashboardRecords = data;
            this.amount = data.LastStatement;
            //if (this.prodType == 'CVN') {
            //    this.pendingCB = data.PendingClipboardsCount;
            //    this.completedCB = data.CompletedClipboardsCount;
            //}
            let dateFormat = this.dashboardRecords.NextAppointment.split(' ');
            if (this.dashboardRecords.NextAppointment != '') {
                let date = dateFormat[0] + ' ' + dateFormat[1] + ', ' + dateFormat[2];//+ ' ' + dateFormat[3] == '' ? (dateFormat[4].replace('AM', ' AM').replace('PM', ' PM')):( dateFormat[3].replace('AM', ' AM').replace('PM', ' PM'));
                let time = dateFormat[3] == '' ? (dateFormat[4].replace('AM', ' AM').replace('PM', ' PM')) : (dateFormat[3].replace('AM', ' AM').replace('PM', ' PM'));
                this.nextApp = date + ' ' + time;
            }
            let medicationList = this.dashboardRecords.CurrentMedications.split(',');
            if (medicationList.length >= 3)
                this.dashboardMedication = medicationList[0] + ', ' + medicationList[1] + ', ' + medicationList[2];
            else
                if (medicationList.length == 2)
                    this.dashboardMedication = medicationList[0] + ', ' + medicationList[1];
                else
                    if (medicationList.length == 1)
                        this.dashboardMedication = medicationList[0];
        });
        this.stmenuService.configuration.apiKeys = headerContext;
        this.stmenuService.configuration.accessToken = environment.portalAccessKey;
        this.stmenuService.getPatientPortalStatementMenu(userData[0].PatientId).map(st => st).subscribe(statements => {
            if (statements.length > 0)
                this.statementId = statements[0].StatementID;
            let headerContext1: { [key: string]: string } = {};
            headerContext1["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.UserPracticeId + "'}";
            this.paymentService.configuration.apiKeys = headerContext1;
            this.paymentService.configuration.accessToken = environment.portalAccessKey;
            this.paymentService.getPatient(userData[0].PatientId).subscribe(pt => {
                if (pt.length > 0) {
                    if (pt[0].Status == 3) {
                        this.activeStatus = false;
                    }
                    else{
                        this.activeStatus = true;
                    }

                    if(pt[0].ShowPaymentButton == 'yes')
                    {
                        this.IsPaymentButtonHide = false;
                    }else{
                        this.IsPaymentButtonHide = true;
                    }   
                }
            });

        });
        let headerContext1: { [key: string]: string } = {};
        headerContext1["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.PracticeID + "'}";
        this.messageTypeService.configuration.apiKeys = headerContext1;
        this.messageTypeService.configuration.accessToken = environment.portalAccessKey;
        this.messageTypeService.getPatientPortalMessageTypes().map(t => t).subscribe(type => {
            this.messageTypes = type;
        });
        this.messageBoardService.configuration.apiKeys = headerContext;
        this.messageBoardService.configuration.accessToken = environment.portalAccessKey;
        //this.messageBoardService.patientPortalMessageBoard('4', environment.UserPracticeId, 'Inbox', this.patId).map(t => t).subscribe(items => {
        this.messageBoardService.patientPortalMessages('Dashboard', this.patId).map(t => t).subscribe(items => {
            this.inboxData = items;//.filter(m => m.ViewedStatus == false);
            let resultArray: any = [];
            this.inboxData.forEach(d => {
                if (d.MessageTypeId == 0) {
                    d.MessageTypeId = 5;
                    d.MessageType = 'Other';
                }
                if (this.timeZone == 'Eastern Standard Time')
                    resultArray.push({ 'MessageId': d.MessageId, 'ViewedStatus': d.ViewedStatus, 'MessageType': d.MessageType, 'MessageSubject': d.MessageSubject, 'SendDatatime': this.datepipe.transform(d.SendDatatime, 'MM/dd/yyyy h:mm a') });
                else {
                    var date = new Date(d.SendDatatime);
                    var utcDate = new Date(date.toUTCString());

                    if (this.timeZone == 'Central Standard Time')
                        utcDate.setHours(utcDate.getHours() - 1);
                    else
                        if (this.timeZone == 'Mountain Standard Time')
                            utcDate.setHours(utcDate.getHours() - 2);
                        else
                            if (this.timeZone == 'Pacific Standard Time')
                                utcDate.setHours(utcDate.getHours() - 3);

                    var usDate = new Date(utcDate);
                    resultArray.push({ 'MessageId': d.MessageId, 'ViewedStatus': d.ViewedStatus, 'MessageType': d.MessageType, 'MessageSubject': d.MessageSubject, 'SendDatatime': this.datepipe.transform(usDate, 'MM/dd/yyyy h:mm a')  });

                }
            });
            this.dataTable = {
                headerRow: ['Message Id', 'Viewed Status', 'Message Type', 'Subject', 'Date & Time'],
                footerRow: [],
                dataRows: resultArray
            };
            this.dataRow = this.dataTable.dataRows;
            this.dataHeader = this.dataTable.headerRow;
        });

        this.appointmentService.configuration.apiKeys = headerContext;
        this.appointmentService.configuration.accessToken = environment.portalAccessKey;
        this.appointmentService.getPatientPortalAppointments(this.patId).map(t => t).subscribe(items => {

            this.appointmentData = items.filter(m => m.Type == 1);
            let resultArray1: any = [];
            this.appointmentData.forEach(d => {
                resultArray1.push({ 'ScheduleID': d.ScheduleId, 'AppointmentDateTime': d.AppointmentDateTime, 'ProviderName': d.ProviderName, 'LocationName': d.LocationName, 'LocAddress': d.LocAddress, 'LocPhone': d.LocPhone, 'VisitTypeDescription': d.VisitTypeDescription, 'IsTeleConsult': d.IsTeleConsult, 'VisitReason': d.VisitReason, 'LocCity': d.LocCity, 'LocZip': d.LocZip, 'ApprovedStatus': d.ApprovedStatus, 'IsToday': (this.datepipe.transform(d.AppointmentDateTime, 'MM/dd/yyyy') == this.todaysDate ? true : false) });
            });
            this.dataTable1 = {
                headerRow: ['Date & Time', 'Provider', 'Location', 'Visit Type', 'Visit Reason', 'Status'],
                footerRow: [],
                dataRows: resultArray1
            };
            this.dataRow1 = this.dataTable1.dataRows;
            this.dataHeader1 = this.dataTable1.headerRow;
        });

        this.medicationService.configuration.apiKeys = headerContext;
        this.medicationService.configuration.accessToken = environment.portalAccessKey;
        this.medicationService.getPatientPortalMedicationList(this.patId).map(t => t).subscribe(items => {
            this.medicationData = items;
            let resultArray2: any = [];

            this.medicationData.forEach(d => {
                resultArray2.push({ 'Name': d.Name, 'eRxdate': d.eRxdate, 'Form': d.Form, 'Route': d.Route, 'Freq': d.Freq, 'Strengthunit': d.Strengthunit, 'Instructions': d.Instructions, 'Quantity': d.Quantity, 'Refills': d.Refills, 'MedicationId': d.medicationID });
            });
            this.dataTable2 = {
                headerRow: ['Medication', 'Start Date', 'Form', 'Route', 'Frequency', 'Strength', 'Instructions', 'Quantity', 'Refills'],
                footerRow: [],
                dataRows: resultArray2
            };
            this.dataRow2 = this.dataTable2.dataRows;
            this.dataHeader2 = this.dataTable2.headerRow;
        });
        let newLogin = localStorage.getItem('newlogin');
        if (newLogin == 'true') {
            $("#newLoginModal").modal("show");
            var str = '';
            str += 'Instructions: Please click the "Send Message" button below to confirm successful access to the patient portal. Once you have clicked "Send Message," you will be able to review your information contained in the portal.<br /><br />';
            str += 'Dear Reception,<br /><br />';
            str += 'I have successfully accessed the patient portal.<br /><br />';
            str += 'Thank you.';
            this.messageModalData.MessageSubject = 'Successful access to patient portal';
            this.messageModalData.MessageBody = str;
            this.messageModalData.MessageId = 0;
            let type = 'Other';
            $("#selectType option:contains(" + type + ")").attr('selected', 'selected');
            $('#mailbody').html(str);
        }
    }
    sendMessage(type) {
        let userData = JSON.parse(localStorage.getItem('usersession'));
        this.msgType = type;
        let headerContext: { [key: string]: string } = {};
        headerContext["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.UserPracticeId + "'}";
        this.provService.configuration.apiKeys = headerContext;
        this.provService.configuration.accessToken = environment.portalAccessKey;
        this.provService.getProviderDetailsForRegUser(userData[0].PatientId).map(t => t).subscribe(provData => {
            this.messageModalData.DestinationRoleId = 4;
            this.messageModalData.SendType = type;
            this.messageModalData.Priority = "Urgent";
            this.messageModalData.MessageType = '5';//$("#selectType").val().toString();
            this.messageModalData.Sender = userData[0].UserName;
            this.messageModalData.MessageBody = $('#mailbody').html();
            this.messageModalData.MessageId = 0;
            this.messageModalData.PatientId = userData[0].PatientId;
            this.messageModalData.PMessageSubject = 'Thank You for using the Patient Portal';
            var str = '';
            str += "Dear " + userData[0].UserName + ",<br><br>";
            str += "Thank You for connecting with us through our Patient Portal.<br><br>";
            str += "Our Patient Portal is a convenient way to manage your healthcare and allows you to easily and securely communicate with our practice. It allows you to view your Appointments, Demographics, Medication List, Allergy List, Immunization List, Lab Results, Statements and fill out forms before coming into the office<br><br>";
            str += "Have your complete health records at your finger tips.<br><br>";
            str += "Regards,<br>"
            str += "<b>" + provData.ProviderName + "</b><br>";
            str += provData.PracticeName + "<br>";
            str += provData.LocName + "<br>";
            str += provData.LocPhone + "<br>";
            this.messageModalData.PMessageBody = str;
            let headerContext1: { [key: string]: string } = {};
            headerContext1["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.PracticeID + "'}";
            this.sendmsgService.configuration.apiKeys = headerContext1;
            this.sendmsgService.configuration.accessToken = environment.portalAccessKey;
            this.sendmsgService.NewLoginMessage(this.messageModalData, environment.UserPracticeId, userData[0].PatientId).map(t => t).subscribe(type => {
                $("#newLoginModal").modal("hide");
                localStorage.setItem('newlogin', 'false')
            });
        });

    }

    ngAfterViewInit() {
        this.tokenService.setDashboardDatatable('dbinbox', 'new messages');
        this.tokenService.setDashboardDatatable('dbappointment', 'future appointments');
        this.tokenService.setDashboardDatatable('dbmedication', 'current medications');
        if (this.prodType == 'CVN')
            this.tokenService.setDashboardDatatable('dbclipboard', 'clipboards');
        console.clear();
        if (this.flag == 'Inbox') {

            $('#dbinbox_wrapper').show();
            $('#dbclipboard_wrapper').hide();
        }
        else {
            $('#dbclipboard_wrapper').show();
            $('#dbinbox_wrapper').hide();
        }
        $('#dbappointment_wrapper').hide();
        $('#dbmedication_wrapper').hide();
        $('.dataTables_scroll').css('height', '340px');
        setTimeout(() => {
            this.spinner.hide();
        }, 2000);
    }
    loadInbox() {
        this.isDetails = true;
        this.flag = 'Inbox';
        $('#dbinbox_wrapper').show();
        $('#dbappointment_wrapper').hide();
        $('#dbmedication_wrapper').hide();
        $('#dbclipboard_wrapper').hide();
    }
    loadAppointment() {
        this.isDetails = true;
        this.flag = 'Appointments';
        $('#dbinbox_wrapper').hide();
        $('#dbappointment_wrapper').show();
        $('#dbmedication_wrapper').hide();
        $('#dbclipboard_wrapper').hide();

    }
    loadMedication() {
        this.isDetails = true;
        this.flag = 'Medications';
        $('#dbinbox_wrapper').hide();
        $('#dbappointment_wrapper').hide();
        $('#dbmedication_wrapper').show();
        $('#dbclipboard_wrapper').hide();
    }
    loadClipboard() {
        this.isDetails = true;
        this.flag = 'Clipboard';
        $('#dbinbox_wrapper').hide();
        $('#dbappointment_wrapper').hide();
        $('#dbmedication_wrapper').hide();
        $('#dbclipboard_wrapper').show();
    }
    loadStatement() {
        $('#dbinbox_wrapper').hide();
        $('#dbappointment_wrapper').hide();
        $('#dbmedication_wrapper').hide();
        $('#dbclipboard_wrapper').hide();
        this.flag = 'Statement';
        if (this.statementId > 0) {
            this.isDetails = true;
            let headerContext: { [key: string]: string } = {};
            headerContext["Context"] = "{'userid': '" + this.userId + "','practiceid': '" + environment.UserPracticeId + "'}";
            this.statementService.configuration.apiKeys = headerContext;
            this.statementService.configuration.accessToken = environment.portalAccessKey;
            this.statementService.GetStatementReport(this.statementId).map(t => t).subscribe(result => {
                let file = new Blob([result], { type: 'application/pdf' });
                this.statementURL = this.sanitizer.bypassSecurityTrustResourceUrl(
                    URL.createObjectURL(file) + '#toolbar=0&navpanes=0&scrollbar=0'
                );
            });
        }
        else
            this.isDetails = false;
    }
    goToPayment() {
        localStorage.setItem('amount', this.amount);
        this.router.navigate(['dashboard', 'financials', 'patientpayments']);
    }
    redirectToForm() {
        if (this.flag == 'Inbox')
            this.router.navigate(['dashboard', 'messages', 'Inbox']);
        else
            if (this.flag == 'Appointments')
                this.router.navigate(['dashboard', 'clinical', 'appointments']);
            else
                if (this.flag == 'Medications')
                    this.router.navigate(['dashboard', 'clinical', 'medicationlist']);
                else
                    if (this.flag == 'Clipboard')
                        this.router.navigate(['dashboard', 'clipboards', 'todolist']);
                    else
                        if (this.flag == 'Statement') {
                            localStorage.setItem('reqParam', this.statementId.toString());
                            this.router.navigate(['dashboard', 'financials', 'statement'], { state: { statementId: this.statementId.toString() } });
                        }
    }

    redirectToRequestAppointments(){
        this.isDetails = true;
        this.flag = 'NewAppointments';
        $('#dbinbox_wrapper').hide();
        $('#dbappointment_wrapper').hide();
        $('#dbmedication_wrapper').hide();
        $('#dbclipboard_wrapper').hide();
        this.router.navigate(['dashboard', 'appointments', 'requestappointment']);
    }

    viewData(event) {
        let userData = JSON.parse(localStorage.getItem('usersession'));
        let msId = event.currentTarget.cells[0].innerText.trim();
        let selectedRow: any = this.inboxData.filter(m => m.MessageId == msId);
        this.modalTitle = 'View Message';
        this.msgModalData.MessageType = selectedRow[0].MessageType;
        this.msgModalData.MessageSubject = selectedRow[0].MessageSubject;
        this.msgModalData.MessageBody = selectedRow[0].MessageBody.replace(/(?:\r\n|\r|\n)/g, '<br>').replace(/>>/g, '');
        this.msgModalData.MessageId = selectedRow[0].MessageId;
        $("#inbSelectType").val(selectedRow[0].MessageTypeId);
        $("#inbSelectType").prop('disabled', true);
        $("#msgSub").prop('disabled', true);
        //let headerContext: { [key: string]: string } = {};
        //  headerContext["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.PracticeID + "'}";
        // this.sendmsgService.configuration.apiKeys = headerContext;
        // this.sendmsgService.configuration.accessToken = environment.portalAccessKey;
        //this.msgModalData.ViewedStatus = true;
        //this.msgModalData.MessageType = '0';
        //this.msgService.patientPortalSendMessage(this.msgModalData, environment.UserPracticeId).subscribe(type => {

        //});
        $("#dbModal").modal("show");
    }
    openClipboard(childView) {
        this.router.navigate(['dashboard', 'clipboards', childView]);
    }
    mmdNotification(scheduleID) {
        this.router.navigate(['dashboard', 'clinical', 'mmdnotification'], { queryParams: { ScheduleID: scheduleID } });
    }
}

